import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Click on the button below to review and confirm your payment information.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'We are working with Stripe to handle payments. Stripe is the most secure payment platform used by the biggest companies worldwide.',
      form: {
        terms_acceptance: {
          label:
            'By proceeding, you agree to our <FoodAmigosTerms>Services Agreement</FoodAmigosTerms> and the <StripeTerms>Stripe Connected Account Agreement.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe still needs the details below, or could not verify them:',
        errors: 'Errors',
        awaiting_verification: 'Your Stripe account is being verified',
        awaiting_verification_description:
          'We are waiting for Stripe to finish verifying your business. You can review your profile in the meantime.',
        details_hint:
          'Stripe checks names, addresses and phone numbers against official records. If one is wrong, correct it in My info → Personal Information, and Stripe checks it again. You can add anything else Stripe asks for in your Stripe profile.',
        requirements_hint:
          'Some of these are documents, such as your ID: upload them in the previous step, {{step}}, then come back here.',
        requirements_hint_profile: 'Some of these are documents, such as your ID: upload them in your Stripe profile.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Owner',
          representative: 'Representative',
          business: 'Business',
        },
        details: {
          first_name: 'First name',
          last_name: 'Last name',
          email: 'Email',
          phone: 'Phone number',
          dob: 'Date of birth',
          id_number: 'ID number',
          nationality: 'Nationality',
          address: 'Street and house number',
          city: 'City',
          postal_code: 'Postal code',
          state: 'State',
          country: 'Country',
          id_document: 'ID document',
          proof_of_address: 'Proof of address',
          job_title: 'Job title',
          business_name: 'Legal business name',
          tax_id: 'Tax number',
          vat_id: 'VAT ID',
          registration_number: 'Registration number',
          website: 'Website',
          industry: 'Industry',
          product_description: 'Description of what you sell',
          support_phone: 'Customer support phone number',
          owners: 'Confirmation of the owners',
          directors: 'Confirmation of the directors',
          executives: 'Confirmation of the executives',
          registration_document: 'Business registration document',
          bank_account: 'Bank account for payouts',
          business_type: 'Business type',
          terms: "Acceptance of Stripe's terms",
          bank_account_proof: 'Proof of bank account ownership',
          tax_id_document: 'Tax number document',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'We are working with Adyen to handle payments. Adyen is one of the most secure payment platform used by the biggest companies worldwide.',
    },
  },
  labels: {
    verified: 'Your {{paymentGateway}} account is verified',
    verified_description:
      'Verification is complete for {{paymentGateway}}. You can still manage your profile if needed.',
  },
  buttons: {
    proceed: 'Confirm my payment info',
    copy_link: 'Copy link',
    back: 'Back',
  },
  toasts: {
    something_went_wrong: 'Something went wrong, please contact technical support',
  },
};
